import React from 'react';
import useTheme from 'branding/theme';
import ClickableOpacity from '../ClickableOpacity';
import CaretIcon from '../../icons/utility/CaretIcon';
import Span from '../../typography/Span';
import useComponentMargin from '../../hooks/useComponentMargin';
export const CaretButton = ({ isExpanded = false, altExpanded = 'Collapse', altCollapsed = 'Expand', directionExpanded = 'down', directionCollapsed = 'forward', size = 'utility', textBefore, styles, textAfter, ...rest }) => {
    const alt = isExpanded ? altExpanded : altCollapsed;
    const direction = isExpanded ? directionExpanded : directionCollapsed;
    const { typography } = useTheme();
    const textMargin = useComponentMargin({ marginRight: 'small' });
    const mergedStyles = {
        ...styles,
        display: 'flex',
        alignItems: 'center'
    };
    const textStyles = {
        ...typography.paragraph.regular,
        ...textMargin
    };
    return (React.createElement(ClickableOpacity, { "aria-expanded": isExpanded, alt: alt, styles: mergedStyles, ...rest },
        textBefore && React.createElement(Span, { styles: textStyles }, textBefore),
        React.createElement(CaretIcon, { size: size, direction: direction }),
        textAfter && React.createElement(Span, { styles: textStyles }, textAfter)));
};
export default CaretButton;
//# sourceMappingURL=index.js.map